import {RDate} from '@app/core/models/rDate.model';
import {User} from '@app/core/models/user.model';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {BaseModel} from '@app/core/models/base.model';

export class FileEntry extends BaseModel {
	public id: number;
	public original_file_name: string;
	public file_name: string;
	public user: User;
	public size: number;
	public extension: string;
	public created_at: RDate;
	public updated_at: RDate;

	constructor(tenantTZ: string, interService: InternationalizationService) {
		super(tenantTZ, interService);
	}

	public humanReadableSize(): any {
		if (this.size === 0) {
			return '0 KB';
		}
		const i = Math.floor(Math.log(this.size) / Math.log(1024));

		return (this.size / Math.pow(1024, i)).toFixed(1).replace('.', ',') + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i];
	}

	public fileIconClass(): string {
		return {
			ai: 'fa-file-image',
			avi: 'fa-file-video',
			bmp: 'fa-file-image',
			csv: 'fa-file-csv',
			doc: 'fa-file-word',
			docx: 'fa-file-word',
			flv: 'fa-file-video',
			gif: 'fa-file-image',
			h264: 'fa-file-video',
			ico: 'fa-file-image',
			jpeg: 'fa-file-image',
			jpg: 'fa-file-image',
			key: 'fa-file-word',
			mov: 'fa-file-video',
			mp4: 'fa-file-video',
			mpeg: 'fa-file-audio',
			mpg: 'fa-file-audio',
			odp: 'fa-file-powerpoint',
			ods: 'fa-file-excel',
			odt: 'fa-file-word',
			pdf: 'fa-file-pdf',
			png: 'fa-file-image',
			pps: 'fa-file-powerpoint',
			pptx: 'fa-file-powerpoint',
			ps: 'fa-file-image',
			psd: 'fa-file-image',
			rar: 'fa-file-archive',
			rm: 'fa-file-audio',
			rtf: 'fa-file-word',
			svg: 'fa-file-image',
			swf: 'fa-file-video',
			tif: 'fa-file-image',
			tiff: 'fa-file-image',
			txt: 'fa-file-word',
			vob: 'fa-file-video',
			wks: 'fa-file-excel',
			wmv: 'fa-file-audio',
			wpd: 'fa-file-word',
			wps: 'fa-file-word',
			xlr: 'fa-file-excel',
			xls: 'fa-file-excel',
			xlsx: 'fa-file-excel',
			yz: 'fa-file-archive',
			zip: 'fa-file-archive',
		}[this.extension.toLowerCase()];
	}

	public deserialize(input: any): this {
		Object.assign(this, input);
		if (input.created_at) {
			this.created_at = new RDate(this.tenantTZ, this.interService).deserialize(input.created_at);
		}
		if (input.updated_at) {
			this.updated_at = new RDate(this.tenantTZ, this.interService).deserialize(input.updated_at);
		}
		if (input.user) {
			this.user = new User(this.tenantTZ, this.interService).deserialize(input.user);
		}

		return this;
	}
}
